module.exports = __webpack_public_path__ + "static/k-drinks-2e0588822498fdb3651754459b4a88d1.jpg";